<template>
  <div class="contact-us-block">
    <h4 class="footer-block-title">聯絡我們</h4>
    <div class="social-contact-list">
      <a
        href="https://www.facebook.com/OHBottech"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          class="footer-icon"
          src="@/assets/footer/footer-facebook.png"
          alt="facebook-icon"
        />
      </a>
      <a
        href="https://www.instagram.com/beautyohbot"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          class="footer-icon"
          src="@/assets/footer/footer-instagram.png"
          alt="instagram-icon"
        />
      </a>

      <a
        href="https://line.me/R/ti/p/@568tfwek"
        target="_blank"
        rel="noopener noreferrer"
        class="line-button"
      >
        <img
          class="footer-icon !w-[28px] pr-[5px]"
          src="@/assets/footer/footer-line.png"
          alt="line-icon"
        />
        立即體驗
      </a>
    </div>
    <div
      class="footer-block-content"
    >
      <p><a href="https://www.wishmobile.com/">威許移動股份有限公司</a></p>
      <p>聯絡電話：02-2581-5321</p>
      <p>
        聯絡地址：台北市中山區中山北路二段 106 - 2 號 9 樓
      </p>
    </div>
  </div>
</template>

<script setup></script>

<style scoped lang="postcss">
.contact-us-block {
  @apply text-center;
}
.footer-block-title {
  @apply text-[32px] text-primary-100 pb-[24px] text-left;
  @apply <laptop:(text-[20px] leading-[28.96px] tracking-[2px] pt-[24px] pb-[12px] text-left);
}
.footer-block-content {
  @apply mt-[20px] flex flex-col gap-[8px] text-[20px] font-normal text-left;
  @apply <laptop:(text-[16px] gap-[8px]);
  p {
    @apply leading-[1.3]
  }
}
.footer-icon {
  @apply w-[40px];
}

.social-contact-list {
  @apply flex gap-[24px];
}

.line-button {
  @apply flex items-center bg-primary-100 text-white rounded-[15px] flex items-center py-[7px] pl-[12px] pr-[24px];
}
</style>
